module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Robin S. Engel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/overview#overview"
    }
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Stephen K. Rice and Michael D. White")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART I")]), _vm._v(" The Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intropart01#intro-part01"
    }
  }, [_vm._v("Introduction to Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Stephen K. Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1 A Sketch of the Policeman’s Working Personality")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Jerome H. Skolnick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("2 Driving While Black: A Statistician Proves That Prejudice Still Rules the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("John Lamberth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03"
    }
  }, [_vm._v("3 The Stories, the Statistics, and the Law: Why “Driving While Black” Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("David A. Harris")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Legitimacy and Cooperation: Why Do People Help the Police Fight Crime in Their Communities?")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Tom R. Tyler and Jeffrey A. Fagan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Race and Policing in Different Ecological Contexts")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Ronald Weitzer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Racially Biased Policing: A Review of the Judicial and Legislative Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Delores Jones-Brown and Brian A. Maule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART II")]), _vm._v(" The Methods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intropart02#intro-part02"
    }
  }, [_vm._v("Introduction to Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Michael D. White")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Methods for Assessing Racially Biased Policing")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Greg Ridgeway and John MacDonald")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Using Geographic Information Systems to Study Race, Crime, and Policing")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Matt R. Nobles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Beyond Stop Rates: Using Qualitative Methods to Examine Racially Biased Policing")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Rod K. Brunson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 State of the Science in Racial Profiling Research: Substantive and Methodological Considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Meaghan Paulhamus, Robert J. Kane, and Alex R. Piquero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART III")]), _vm._v(" The Research")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intropart03#intro-part03"
    }
  }, [_vm._v("Introduction to Part III")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Michael D. White")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Driving While Black: Bias Processes and Racial Disparity in Police Stops")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Patricia Warren, Donald Tomaskovic-Devey, William R. Smith, Matthew Zingraff, and Marcinda Mason")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Citizens’ Demeanor, Race, and Traffic Stops")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Robin S. Engel, Charles F. Klahm IV, and Rob Tillyer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Street Stops and Broken Windows Revisited: The Demography and Logic of Proactive Policing in a Safe and Changing City")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Jeffrey A. Fagan, Amanda Geller, Garth Davies, and Valerie West")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Community Characteristics and Police Search Rates: Accounting for the Ethnic Diversity of Urban Areas in the Study of Black, White, and Hispanic Searches")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Karen F. Parker, Erin C. Lane, and Geoffrey P. Alpert")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Blind Justice: Police Shootings in Memphis")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("James J. Fyfe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Race, Bias, and Police Use of the TASER: Exploring the Available Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Michael D. White and Jessica Saunders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04#part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART IV")]), _vm._v(" The Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intropart04#intro-part04"
    }
  }, [_vm._v("Introduction to Part IV")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Stephen K. Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Space, Place, and Immigration: New Directions for Research on Police Stops")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Brian J. Stults, Karen F. Parker, and Erin C. Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Revisiting the Role of Latinos and Immigrants in Police Research")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Ramiro Martínez Jr")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 New Avenues for Profiling and Bias Research: The Question of Muslim Americans")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Stephen K. Rice and William S. Parkin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Preventing Racially Biased Policing through Internal and External Controls: The Comprehensive Accountability Package")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Michael D. White")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Democratic Policing: How Would We Know It If We Saw It?")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Matthew J. Hickman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Moving Beyond Profiling: The Virtues of Randomization")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("Bernard E. Harcourt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/about#about",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0